module.exports = __webpack_public_path__ + "img/lensflare3.20a2bd3c.png";